import React, { Component } from "react";
import styled from "styled-components";
import EditorLabel from "editor/components/EditorLabel";
import { PropListItem, PropLabel } from "./styles";

const PropRef = styled.span`
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #5e5e5e;
  &:after{
    content: "";
    width: 0;
    height: 0; 
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    margin-left: 5px;
    ${props =>
      props.open
        ? "border-bottom: 8px solid #595959;"
        : "border-top: 8px solid #595959;"}
    display: ${props => (props.visible ? "none;" : "block;")}
  }
`;

const CustomPropListItem = styled(PropListItem)`
  flex-direction: column;
`;

const LabelContainer = styled.div`
  display: flex;
  width: 100%;
  cursor: ${props => (props.visible ? "default" : "pointer")};
`;

const ChildrenContainer = styled.div`
  width: 100%;
  ${props =>
    // eslint-disable-next-line no-nested-ternary
    props.visible
      ? "height: auto;"
      : props.open
      ? "height: auto;"
      : "height: 0;"}
  overflow: hidden;
`;

class Collapse extends Component {
  state = {
    open: false
  };

  openToggle = () => {
    const { visible } = this.props;
    const { open } = this.state;

    if (!visible) {
      this.setState({ open: !open });
    }
  };

  render() {
    const {
      label,
      children,
      propRef,
      visible,
      suffix,
      locale,
      tooltip,
      ...props
    } = this.props;
    const tooltipText = (tooltip && tooltip[locale]) || null;

    const { open } = this.state;

    return (
      <CustomPropListItem>
        <LabelContainer onClick={this.openToggle} visible={visible}>
          <PropLabel>
            <EditorLabel tooltip={tooltipText}>{label[locale]}</EditorLabel>
          </PropLabel>
          <PropRef open={open} visible={visible}>
            {propRef && propRef}
            {suffix && suffix}
          </PropRef>
        </LabelContainer>
        <ChildrenContainer visible={visible} open={open}>
          {children}
        </ChildrenContainer>
      </CustomPropListItem>
    );
  }
}

export default Collapse;
